export const getStorageValue = (fieldName) => {
  try {
    const localStorageValue = !!localStorage.getItem(fieldName) ? JSON.parse(localStorage.getItem(fieldName)) : null;
    // console.log(`localStorageValue ${fieldName}`, localStorageValue);
    return localStorageValue;
  } catch (e) {
    return null;
  }
};
